import { render, staticRenderFns } from "./communicationTable.vue?vue&type=template&id=62e45b98&scoped=true"
import script from "./communicationTable.vue?vue&type=script&lang=js"
export * from "./communicationTable.vue?vue&type=script&lang=js"
import style0 from "./communicationTable.vue?vue&type=style&index=0&id=62e45b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e45b98",
  null
  
)

export default component.exports